export const STATUS = {
  COMPLETE: "COMPLETE",
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  FAIL: "FAIL",
};

export const STATUS_TITLE = {
  COMPLETE: "Complete",
  PENDING: "Pending",
  PROCESSING: "Processing",
  FAIL: "Fail",
};
